export default "__VITE_ASSET__D$hoeKZW__"